//TODO: discuss if enumObjects should be imported in components, or should we call them by their names here ?

export const GetKeyByValue1 = (keyToMatch, enumObject) => {
  return Object.keys(enumObject).find((key) => enumObject[key] === keyToMatch);
  //TODO: this is an alternative, discuss which to use
};

export const GetValueByKey = (keyToMatch, enumObject) => {
  return enumObject[keyToMatch];
};

export const GetKeyByValue = (valueToMatch, enumObject) => {
  for (var name in enumObject) {
    var value = enumObject[name];
    if (value === valueToMatch) return name;
  }
};

export const MapObjectIntoArray = (enumObject) => {
  let Array = [];
  return Object.assign({}, ...Object.entries(enumObject).map(([key, value]) => (Array = [...Array, { [key]: value }])));
};

export const designTypesEnum = {
  Detail_1: 0,
  DualText: 1,
  MonoText: 2,
  Summary_1: 3,
  Summary_LoadingBar: 4,
  Detail_LoadingBar: 5,
  Detail_2: 6,
  AnsweringTendencyDesign_1: 7,
  TestScaleDesign_1: 8,
  Summary_2: 9,
  Detail_3: 10,
  Detail_4: 11,
  Detail_5: 12,
  Summary_Scaleless_1: 13,
  Summary_Scaleless_2: 14,
  MonoText_Frameless: 15,
  Summary_1_Right: 16,
  Summary_2_Right: 17,
  Summary_LoadingBar_Right: 18,
  Detail_LoadingBar_Short: 19,
  Detail_CircleBar: 20,
  Detail_Ozo: 21,
  Detail_Ozo_Inline: 22,
  Detail_Ozo_Circle: 23,
  Detail_Ozo_Inline_Circle: 24,
  Detail_Ozo_Loading_Bar: 25,
  Detail_Ozo_Badge_Bar: 26,
  Detail_Textual: 27,
  Detail_Textual_PBar: 28,
  Summary_Ten_Scale: 29,
  Detail_Textual_10_scale: 30,
  Detail_Textual_L_Bar: 31,
  Summary_L_Bar: 32,
  Summary_L_Bar_Thin: 33,
  Summary_2_Header: 34,
  Summary_Scoreless_Header: 35,
  Summary_Scoreless_Header_Small: 36,
  MonoText_Frameless_H: 37,
};

export const companyUserEnum = {
  Manager: 0,
  Recruiter: 1,
};

export const applicationTypeEnum = {
  Test: 0,
  Inventory: 1,
  Survey: 2,
  Assessment: 3,
};

export const imageTypeEnum = {
  ApplicationIcon: 0,
  PdfCover: 1,
  PdfInfoPage: 2,
  CompanyIcon: 3,
  CompanyLogo: 4,
};

export const warningFlagTypeEnum = {
  fullscreen: 0,
  tabSwitch: 1,
  mouseOut: 2,
  pageVisibility: 3,
  extraScreen: 4,
  pageBlur: 5,
};

export const folderEnum = {
  candidate: "candidate/",
  cv: "cv/",
  info: "info/",
  logo: "logo/",
  question: "question/",
  scheme: "scheme/",
  profile: "profile/",
  help: "help/",
};

export const userRolesEnum = {
  SuperAdmin: 0,
  Admin: 1,
  User: 2,
};

export const requestTypeEnum = {
  connection: 0,
  help: 1,
};
